import { useEffect } from 'react'
import { injected } from '../utils'
import { useEthers } from './useEthers'

export function useInactiveListener(skip = false) {
  const { active, error, activate } = useEthers()

  useEffect(() => {
    const { ethereum } = window as any

    if (ethereum && ethereum.on && !active && !error && !skip) {
      const handleChainChanged = () => {
        activate(injected, undefined, true).catch((error) => {
          console.error('Failed to activate after chain changed', error)
        })
      }

      const handleAccountsChanged = (accounts: string[]) => {
        if (accounts.length > 0) {
          activate(injected, undefined, true).catch((error) => {
            console.error('Failed to activate after accounts changed', error)
          })
        }
      }

      ethereum.on('chainChanged', handleChainChanged)
      ethereum.on('accountsChanged', handleAccountsChanged)

      return () => {
        if (ethereum.removeListener) {
          ethereum.removeListener('chainChanged', handleChainChanged)
          ethereum.removeListener('accountsChanged', handleAccountsChanged)
        }
      }
    }
    return undefined
  }, [active, error, skip, activate])
}
